import { api } from "source/registrations/api/client"
import { routes, buildPath } from "source/shared/apiRoutes"

export const postReservations = (eventId, options = {}) => {
  const [path, params] = buildPath(routes.registrations.reservations, {
    eventId,
    ...options,
  })

  return api.post(path, params)
}

export const patchReservation = (eventId, reservationUuid, options = {}) => {
  const [path, params] = buildPath(routes.registrations.reservation, {
    eventId,
    reservationUuid,
    ...options,
  })

  return api.patch(path, params)
}
